const SHOW_SPINNER = 'SHOW_SPINNER';
const START_SPINNER_REQUEST = 'START_SPINNER_REQUEST';
const FINISH_SPINNER_REQUEST = 'FINISH_SPINNER_REQUEST';

export {
  SHOW_SPINNER,
  START_SPINNER_REQUEST,
  FINISH_SPINNER_REQUEST,
};
